import Image from '@tiptap/extension-image';

/** Stores the B2 key as `data-b2-key` so expired signed `src` URLs can be batch-refreshed. */
const SignedImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      b2Key: {
        default: null as string | null,
        parseHTML: (el) => el.getAttribute('data-b2-key'),
        renderHTML: (attrs: Record<string, unknown>) => {
          const key = attrs.b2Key;
          if (!key || typeof key !== 'string') return {};
          return { 'data-b2-key': key };
        },
      },
    };
  },
});

export default SignedImage;
